import { css, cx } from 'linaria';
import { FilterMenu } from 'components/list-filter-menu/list-filter-menu';
import { capitalizeFirstLetter } from 'common/utilities';
import { PinFilledIcon } from 'components/icons/PinFilledIcon';
import { PinIcon } from 'components/icons/PinIcon';
import { EditIcon } from 'components/icons/EditIcon';
import { DeleteIcon } from 'components/icons/DeleteIcon';
import { buttonReset } from 'components/buttons/button-reset';
import { bottomTooltipDelayed } from 'components/tooltip/tooltip';
import { useTranslation } from 'next-i18next';
import { myListHeaderStyle } from './my-list-header';
import { ListSort } from 'components/list-sort/list-sort';
const tagPageHeaderStyle = "t6whhbv";
export const UnTaggedHeader = ({
  subset,
  filter,
  tag,
  sortOrder,
  handleNewest,
  handleOldest
}) => <header className={myListHeaderStyle}>
    <h1 className="pageTitle">not tagged</h1>
    <FilterMenu subset={subset} filter={filter} tag={tag} />
    <ListSort sortOrder={sortOrder} handleNewest={handleNewest} handleOldest={handleOldest} />
  </header>;
export const TaggedHeader = ({
  subset,
  filter,
  title,
  tag,
  pinTag,
  editTag,
  deleteTag,
  isPinned,
  sortOrder,
  handleNewest,
  handleOldest
}) => {
  const {
    t
  } = useTranslation();
  return <div className={tagPageHeaderStyle}>
      <header className={myListHeaderStyle}>
        <h1 className="pageTitle" data-cy="page-title">
          {capitalizeFirstLetter(title)}
        </h1>
        <FilterMenu subset={subset} filter={filter} tag={tag} />
        <ListSort sortOrder={sortOrder} handleNewest={handleNewest} handleOldest={handleOldest} />
      </header>
      <div className="tag-actions">
        <button aria-label={isPinned ? t('nav:unpin-tag', 'Unpin Tag') : t('nav:pin-tag', 'Pin Tag')} data-tooltip={isPinned ? t('nav:unpin-tag', 'Unpin Tag') : t('nav:pin-tag', 'Pin Tag')} data-cy={isPinned ? 'tag-unpin' : 'tag-pin'} className={cx(buttonReset, bottomTooltipDelayed)} onClick={pinTag}>
          {isPinned ? <PinFilledIcon /> : <PinIcon />}
        </button>

        <button aria-label={t('nav:edit-tag', 'Edit Tag')} data-tooltip={t('nav:edit-tag', 'Edit Tag')} data-cy="tag-edit" className={cx(buttonReset, bottomTooltipDelayed)} onClick={editTag}>
          <EditIcon />
        </button>

        <button aria-label={t('nav:delete-tag', 'Delete Tag')} data-tooltip={t('nav:delete-tag', 'Delete Tag')} data-cy="tag-delete" className={cx(buttonReset, bottomTooltipDelayed)} onClick={deleteTag}>
          <DeleteIcon />
        </button>
      </div>
    </div>;
};
export const TagPageHeader = ({
  subset,
  filter,
  title,
  tag,
  pinTag,
  editTag,
  deleteTag,
  isPinned,
  sortOrder,
  handleNewest,
  handleOldest
}) => {
  const TagHeader = '_untagged_'.includes(title) ? UnTaggedHeader : TaggedHeader;
  return subset ? <TagHeader subset={subset} filter={filter} title={title} tag={tag} pinTag={pinTag} editTag={editTag} deleteTag={deleteTag} isPinned={isPinned} sortOrder={sortOrder} handleNewest={handleNewest} handleOldest={handleOldest} /> : null;
};

require("./tag-page-header.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-page-header.js");